<div class="sidebar">
  <div class="menu-top">
    <div class="menu-item menu-item-first" (click)="toggleSidebar()">
      @if (!collapsed) {
      <img type="image/png" src="assets/icon/favicon.png" width="25" />
      } @if (!collapsed) {
      <b>{{ "navigation.brand" | translate }}</b>
      }
      <ion-icon
        [name]="collapsed ? 'chevron-forward-outline' : 'chevron-back-outline'"
      ></ion-icon>
    </div>
    @for (item of topMenu; track item) {
    <div
      class="menu-item"
      [routerLink]="item.routerLink"
      routerLinkActive="active"
      [attr.title]="collapsed ? (item.title | translate) : null"
    >
      <ion-icon [name]="item.icon"></ion-icon>
      @if (!collapsed) {
      <span style="margin-left: 12px">{{ item.title | translate }}</span>
      }
    </div>
    }
  </div>

  <div class="menu-bottom">
    @for (item of bottomMenu; track item) {
    <div
      class="menu-item"
      [routerLink]="item.routerLink"
      routerLinkActive="active"
      [attr.title]="collapsed ? (item.title | translate) : null"
    >
      <ion-icon [name]="item.icon"></ion-icon>
      @if (!collapsed) {
      <span style="margin-left: 12px">{{ item.title | translate }}</span>
      }
    </div>
    }
    <div
      (click)="logout()"
      [title]="'navigation.logout' | translate"
      class="menu-item"
    >
      <ion-icon name="log-out-outline"></ion-icon>
      @if (!collapsed) {
      <span style="margin-left: 12px">{{
        "navigation.logout" | translate
      }}</span>
      }
    </div>
  </div>
</div>
